import { MainPracticeUser } from "../features/practiceQuestionsUser/components/MainPracticeUser"
const practiceQuestionsUser = () => {
    return <MainPracticeUser />
}
export default practiceQuestionsUser;